module.exports = __webpack_public_path__ + "img/easy-meatloaf.67312d98.jpg";